<div class="max-w-4xl mx-auto px-6 py-12">
  <div class="bg-white rounded-xl shadow-lg p-8">
    <h2 class="text-3xl font-serif text-gold mb-6">Charger un fichier Excel</h2>


    <!-- File Input -->
   <div class="mb-6">
      <input type="file" accept=".xlsx, .xls" (change)="onFileChange($event)"
             class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300 text-gray-600">
    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage" class="text-red-500 text-sm mb-6">{{ errorMessage }}</div>

    <!-- Product List -->
    <div *ngIf="products.length > 0">
      <h3 class="text-2xl font-serif text-gold mb-6">Produits chargés ({{ products.length }})</h3>
      <ul class="space-y-4">
        <li *ngFor="let product of products" class="p-4 rounded-lg border border-gray-200 hover:bg-gold hover:bg-opacity-10 transition duration-300">
          <div class="text-lg font-serif text-gold">
            <strong>{{ product.name }}</strong> (SKU: {{ product.sku }})
          </div>
          <div class="text-gray-600 mt-1">
            <div>Prix: {{ product.price *13 | currency:'MAD' }}</div>
            <div>Familles: {{ product.familles[0] || 'Aucune' }}</div>
            <div>Sous-familles: {{ product.sousFamilles[0] || 'Aucune' }}</div>
            <div>Images: {{ product.imageURLs.length }} (Featured: {{ product.imageFeaturedUrl || 'Aucune' }})</div>
          </div>
        </li>
      </ul>
    </div>

    <!-- Delete Form -->
    <div class="mt-8">
      <h3 class="text-2xl font-serif text-gold mb-4">Supprimer un produit</h3>
      <form (ngSubmit)="delete()" class="flex items-center space-x-4">
        <input type="text" [(ngModel)]="deleteInput" name="deleteInput" placeholder="Nom du produit"
               class="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300 text-gray-600">
        <button type="submit" class="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition duration-300">
          Supprimer
        </button>
      </form>
    </div>
  </div>
</div>
